<script>
export default {
    name: 'KpTextArea',
    props: {
        maxLength: {
            type: Number,
            default: 0,
        },
    },

    mounted() {
        // because vuetify components do not make the maxlength attribute available, we need to set it programmatic
        if (this.maxLength > 0) {
            this.$refs.textarea?.$refs.input.setAttribute('maxlength', this.maxLength);
        }
    },
};
</script>

<template>
    <v-textarea ref="textarea" v-bind="$attrs" v-on="$listeners" />
</template>

<style scoped></style>
